import apiClient from '../utils/apiClient';

export const pagesAPI = {
  // ─── Public ───────────────────────────────────────────

  getPublishedPages: async () => {
    return await apiClient.get({ url: '/pages' });
  },

  getPageBySlug: async (slug) => {
    return await apiClient.get({ url: `/pages/${slug}` });
  },

  // ─── Admin ────────────────────────────────────────────

  getAllPages: async (category = '') => {
    return await apiClient.get({
      url: '/pages/admin/all',
      params: { category },
    });
  },

  getPageById: async (id) => {
    return await apiClient.get({ url: `/pages/admin/${id}` });
  },

  createPage: async (data) => {
    return await apiClient.post({ url: '/pages', data });
  },

  updatePage: async (id, data) => {
    return await apiClient.put({ url: `/pages/${id}`, data });
  },

  togglePublish: async (id) => {
    return await apiClient.patch({ url: `/pages/${id}/publish` });
  },

  deletePage: async (id) => {
    return await apiClient.delete({ url: `/pages/${id}` });
  },

  // ─── Sections ─────────────────────────────────────────

  addSection: async (pageId, data) => {
    return await apiClient.post({ url: `/pages/${pageId}/sections`, data });
  },

  updateSection: async (pageId, sectionId, data) => {
    return await apiClient.put({ url: `/pages/${pageId}/sections/${sectionId}`, data });
  },

  deleteSection: async (pageId, sectionId) => {
    return await apiClient.delete({ url: `/pages/${pageId}/sections/${sectionId}` });
  },

  reorderSections: async (pageId, sections) => {
    return await apiClient.patch({
      url: `/pages/${pageId}/sections/reorder`,
      data: { sections },
    });
  },

  // ─── Acknowledgement ──────────────────────────────────

  broadcastPage: async (id) => {
    return await apiClient.post({ url: `/pages/${id}/broadcast` });
  },

  getReadStats: async (id) => {
    return await apiClient.get({ url: `/pages/${id}/read-stats` });
  },

  getAcknowledgements: async (id, status = 'all') => {
    return await apiClient.get({
      url: `/pages/${id}/acknowledgements`,
      params: { status },
    });
  },
};
